import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "fail" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "fail__img" }, null, -1)
const _hoisted_3 = { class: "fail__tips" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("li", null, "1、请确保设备和网络正常运行；", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("li", null, "2、请确保设备的供电正常，且未开机绑定状态；", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("li", null, "3、更新设备固件和客户端为最新版后重试；", -1)
const _hoisted_8 = { key: 1 }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("li", null, "请检查磁盘连接是否正常；", -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = {
  key: 0,
  class: "fail-cover"
}
const _hoisted_12 = { class: "fail-dialog" }
const _hoisted_13 = { class: "dialog__body" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("h2", null, "错误信息", -1)
const _hoisted_15 = { class: "tips" }
const _hoisted_16 = { class: "dialog__footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GradientButton = _resolveComponent("GradientButton")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("p", null, _toDisplayString(_ctx.tip), 1),
      _createElementVNode("div", _hoisted_3, [
        (!_ctx.isDiskException)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_4, [
              _hoisted_5,
              _hoisted_6,
              _hoisted_7,
              _withDirectives(_createElementVNode("li", null, _toDisplayString(_ctx.lastTime), 513), [
                [_vShow, _ctx.lastTime]
              ])
            ]))
          : (_openBlock(), _createElementBlock("ul", _hoisted_8, _hoisted_10))
      ]),
      _createVNode(_component_GradientButton, {
        class: "button-fail",
        onClick: _ctx.handleRetry
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.tipBtn), 1)
        ]),
        _: 1
      }, 8, ["onClick"]),
      (_ctx.showFailBtn)
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: "button-fb",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showFailDialog = true))
          }, "反馈错误信息"))
        : _createCommentVNode("", true)
    ]),
    (_ctx.showFailDialog)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createElementVNode("p", _hoisted_15, [
                _createElementVNode("span", null, _toDisplayString(_ctx.connectMessage), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("a", {
                href: "javascript:;",
                class: "button-other",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showFailDialog = false))
              }, " 关闭 "),
              _createElementVNode("a", {
                href: "javascript:;",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.copyClose && _ctx.copyClose(...args)))
              }, " 复制并关闭 ")
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}